import { type SearchRequest } from '@searchkit/api';

import { createQueryFactory } from '~/search-domain/pipelines/player-data/query-factory';
import { type SearchDomainContext } from '~/search-domain/types';

export function buildPlayerDataQuery(_context: SearchDomainContext, searchRequest: SearchRequest) {
  const queryFactory = createQueryFactory();
  return queryFactory(searchRequest);
}
